import React, { useContext } from "react";
// import Input from "../features/Input";
import { AuthContext } from "../context/AuthContext";
import { MdEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import {PermissionsComp} from "../pages/Personnel/DetailPersonnels"
export const ProfilHeader = ({
  namePerson,
  rolePerson,
  detailUserInfo,
  detailPhone,
  detailAdresse,
  detailEmail,
  detailId
}) => {
  const navigate = useNavigate()
  return (
    <div
      className="d-flex align-items-center justify-content-between gap-3 
    conteneur-image-info border border-2 rounded-5 border-dark p-4"
    >
      <section className="d-flex align-items-center gap-5">
        <img src="/person.jpeg" alt="icon" />
        <div>
          <h3 className="my-1">{namePerson}</h3>
          <span className="badge bg-secondary my-1">{rolePerson}</span>
          {detailUserInfo && (
            <>
              <p className="text-secondary my-1">{detailAdresse}</p>
              <p className="text-secondary my-1">{detailEmail}</p>
              <p className="text-secondary my-1">{detailPhone}</p>
            </>
          )}
        </div>
      </section>
      {!detailUserInfo && (
        <button
        onClick={()=>{
          navigate("/profil/edit/"+detailId,{
            state: { message: 'Profil'}
          })
        }}
          className="
          hover-btn
        btn 
        bg-transparent 
        p-1 
        border 
        border-2 
        border-secondary
        rounded-5 
        d-flex 
        align-items-center
        gap-2"
        >
          Modifier
          <MdEdit />
        </button>
      )}
    </div>
  );
};
export const ParagrapheInfo = ({ name, libelle }) => {
  return (
    <p className="col-md-4 col-sm-6">
      <span className="text-secondary">{libelle}</span> <br />
      <span>{name}</span>
    </p>
  );
};

const ProfilSectionInfo = ({ infoPersonnelle }) => {
  return (
    <div className="border border-2 rounded-5 border-dark p-4 my-5">
      <h2>Informations personnelles</h2>
      <section className="d-flex align-items-center">
        <div className="container">
          <div className="row">
            <ParagrapheInfo libelle={"nom"} name={infoPersonnelle.nom} />
            <ParagrapheInfo libelle={"prénoms"} name={infoPersonnelle.prenom} />
            <ParagrapheInfo
              libelle={"Profil"}
              name={infoPersonnelle.role.libelle}
            />
            <ParagrapheInfo
              libelle={"Adresse mail"}
              name={infoPersonnelle.email}
            />
            <ParagrapheInfo
              libelle={"Télephone"}
              name={infoPersonnelle.phone}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

function Profil() {

  const { user } = useContext(AuthContext);
  // const [data, setData] = useState({
  //   password: null,
  //   oldPassword: null,
  //   email: null,
  // });
  // const [isLoading, setIsLoading] = useState(false);
  // const handlePassword = (e) => {
  //   setData({ ...data, password: e.target.value });
  // };
  // const handleoldPassword = (e) => {
  //   setData({ ...data, oldPassword: e.target.value });
  // };

  // const sendData = async () => {
  //   setIsLoading(true);
  //   const dataForChangePassword = {
  //     password: data.password,
  //     oldPassword: data.oldPassword,
  //     email: user.email,
  //   };
  //   const dataForChangeOnlyEmail = {
  //     email: data.email,
  //   };
  //   const dataSend = data.email
  //     ? dataForChangeOnlyEmail
  //     : dataForChangePassword;
  //   const route = data.email
  //     ? axios.put(`users/${user.id}`, dataSend)
  //     : axios.post("modifyPassword", dataSend);
  //   try {
  //     const response = await route;
  //     console.log(response);
  //     if (!response.data.status) {
  //       MySwal.fire({
  //         title: response.data.message,
  //         icon: "info",
  //         showConfirmButton: true,
  //       });
  //       setIsLoading(false);
  //     } else {
  //       setIsLoading(false);
  //       MySwal.fire({
  //         title: response.data.message,
  //         icon: "success",
  //         showConfirmButton: false,
  //         timer: 1500,
  //       });
  //       setData({ password: "", oldPassword: "", email: "" });
  //     }

  //     console.log(response);
  //   } catch (error) {
  //     console.log(error);
  //     MySwal.fire({
  //       title: error.response.data.message,
  //       icon: "info",
  //       showConfirmButton: true,
  //     });
  //     setIsLoading(false);
  //   }
  // };

  // const sendNewPassword = (e) => {
  //   e.preventDefault();
  //   console.log(data);
  //   sendData();
  // };
  return (
    <div className="profil-setting">
      <ProfilHeader
        namePerson={`${user.prenom} ${user.nom}`}
        rolePerson={user.role.libelle}
        detailUserInfo={false}
        detailId={user.id}
      />
      <ProfilSectionInfo infoPersonnelle={user} />
    <PermissionsComp dataPermission={user.permissions} />
    </div>
  );
}

export default Profil;
